import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import { useHistory, Link } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactHtmlParser from 'react-html-parser';

import { API_BASE_URL } from '../../config.js';
import { statisticsAction, statisticsCloseAction } from '../../actions/settingsAction.js';

const Inchargeot = (props) => {
    const { fixNavbar } = props;
    const history = useHistory();

    const [data, setData] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [selectedIds, setSelectedIds] = useState([]);

    // ------------------ FETCH DATA ------------------
    const fetchData = () => {
        axios.get(`${API_BASE_URL}/incharge_overtime_list`, {
            headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` }
        })
        .then(res => setData(res.data))
        .catch(err => console.log(err));
    };

    useEffect(() => {
        fetchData();
    }, []);

    // ------------------ SEARCH ------------------
    const handleSearch = (e) => setSearchTerm(e.target.value);
    const clearInput = () => setSearchTerm("");

    const filteredItems = data.filter(item =>
        `${item.employee_id}${item.employee_name}${item.department_name}`.toLowerCase()
            .includes(searchTerm.toLowerCase())
    );

    // ------------------ PAGINATION ------------------
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const filteredData = filteredItems.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(filteredItems.length / itemsPerPage);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);
    const handleRowsPerPageChange = (e) => {
        setItemsPerPage(Number(e.target.value));
        setCurrentPage(1);
    };

    // ------------------ DEFAULT SELECT ALL ------------------
    useEffect(() => {
        if (filteredData.length > 0) {
            const defaultSelectedIds = filteredData.map(row => row.overtime_id);
            setSelectedIds(defaultSelectedIds);
        } else {
            setSelectedIds([]);
        }
    }, [data, currentPage, searchTerm]);

    // ------------------ SELECT/UNSELECT ALL ------------------
    const toggleSelectAll = () => {
        const currentIds = filteredData.map(row => row.overtime_id);
        const allSelected = currentIds.every(id => selectedIds.includes(id));

        if (allSelected) {
            setSelectedIds(selectedIds.filter(id => !currentIds.includes(id)));
        } else {
            setSelectedIds([...new Set([...selectedIds, ...currentIds])]);
        }
    };
// Only consider selectable rows
const selectableRows = filteredData.filter(row => row.floor_status === 1);

const isAllSelected = selectableRows.length > 0 && selectableRows.every(row => selectedIds.includes(row.overtime_id));


    // ------------------ HANDLE SINGLE CHECKBOX ------------------
    const handleCheckboxChange = (e, id) => {
        if (e.target.checked) {
            setSelectedIds([...selectedIds, id]);
        } else {
            setSelectedIds(selectedIds.filter(item => item !== id));
        }
    };

    // ------------------ APPROVE SELECTED ------------------
    const approveSelected = () => {
        if (selectedIds.length === 0) {
            toast.warn("No records selected!",{
position: "bottom-right"});
            return;
        }

        axios.post(`${API_BASE_URL}/incharge_overtime_approve_bulk`,
            { overtime_ids: selectedIds, status: "Approved" },
            { headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` } }
        )
        .then(res => {
            toast.success("Selected records approved!",{
position: "bottom-right"});
            setSelectedIds([]);
            fetchData();
        })
        .catch(err => {
            toast.error("Failed to approve. Try again.");
            console.log(err);
        });
    };

    return (
        <>
            <ToastContainer />
            <div className={`section-body ${fixNavbar ? "marginTop" : ""}`}>
                <div className="container-fluid">
                    <div className="card">
                        <div className="card-header d-flex justify-content-between align-items-center flex-wrap">
                            {/* Left side: Title + Select All */}
                            <div className="d-flex align-items-center">
                                <h3 className="card-title mb-0" style={{ color: '#e96827', marginRight: '15px' }}>
                                    Overtime List
                                </h3>
                                {/* <button className="btn btn-info" onClick={toggleSelectAll}>
                                    {isAllSelected ? "Unselect All" : "Select All"}
                                </button> */}
                            </div>

                            {/* Right side: Rows per page + Search */}
                            <div className="d-flex align-items-center mt-2 mt-md-0">
                                <select
                                    value={itemsPerPage}
                                    onChange={handleRowsPerPageChange}
                                    style={{ padding: '8px', marginRight: '20px', borderRadius: '4px', border: '1px solid #ccc', backgroundColor: '#BCD1DB' }}
                                >
                                    <option value={10}>10</option>
                                    <option value={25}>25</option>
                                    <option value={50}>50</option>
                                    <option value={100}>100</option>
                                </select>

                                <div style={{ position: "relative", width: "250px" }}>
                                    <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        placeholder="Search"
                                        value={searchTerm}
                                        onChange={handleSearch}
                                        style={{ width: "100%", padding: "10px", paddingRight: "30px", boxSizing: "border-box" }}
                                    />
                                    {searchTerm.length > 0 && (
                                        <span
                                            onClick={clearInput}
                                            style={{ position: "absolute", top: "50%", right: "10px", transform: "translateY(-50%)", cursor: "pointer", color: "#aaa", fontSize: "18px" }}
                                        >
                                            ✖
                                        </span>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className="card-body table-responsive">
                            <table className="table table-hover table-striped table-vcenter text-nowrap mb-0">
                                <thead>
                                    <tr>
                                        <th>                         <input
                type="checkbox"
                
                checked={isAllSelected}
                onChange={toggleSelectAll}
                style={{ cursor: 'pointer' }}
            />
                </th>
                               
                                        <th>Action</th>
                                        <th>Employee Id</th>
                                        <th>Employee</th>
                                        <th>Department</th>
                                        <th>Overtime Hours</th>
                                        <th>Applied On</th>
                                        <th>Reason</th>
                                        <th>Incharge</th>
                                        <th>Hod</th>
                                        <th>HR</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredData.map((row, index) => (
                                        <tr key={index}>
                                            <td>
                                                {row.floor_status === 1 && (
                                                    <input
                                                        type="checkbox"
                                                        checked={selectedIds.includes(row.overtime_id)}
                                                        onChange={(e) => handleCheckboxChange(e, row.overtime_id)}
                                                    />
                                                )}
                                            </td>
                                            <td>
                                                {row.floor_status === 1 && (
                                                    <Link to={`/inchargeotdetails?id=${row.overtime_id}`} title="View Details">
                                                        <i className="fe fe-maximize" />
                                                    </Link>
                                                )}
                                            </td>
                                            <td>{row.employee_id}</td>
                                            <td>{row.employee_name}</td>
                                            <td>{row.department_name}</td>
                                            <td>{row.overtime_hour}</td>
                                            <td>{row.applied_on}</td>
                                            <td>{row.reason}</td>
                                            <td>{ReactHtmlParser(row.incharge_status)}</td>
                                            <td>{ReactHtmlParser(row.hod_status)}</td>
                                            <td>{ReactHtmlParser(row.hr_status)}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>

                            <button className="btn btn-warning mt-3" onClick={approveSelected}>
                                Approve Selected
                            </button>

                            <nav aria-label="Page navigation" className="mt-3">
                                <ul className="pagination justify-content-end">
                                    <li className="page-item">
                                        <button className="page-link" onClick={() => paginate(1)}>First</button>
                                    </li>
                                    {Array.from({ length: totalPages }, (_, i) => (
                                        <li className="page-item" key={i + 1}>
                                            <button className="page-link" onClick={() => paginate(i + 1)}>{i + 1}</button>
                                        </li>
                                    ))}
                                    <li className="page-item">
                                        <button className="page-link" onClick={() => paginate(totalPages)}>Last</button>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

const mapStateToProps = (state) => ({
    fixNavbar: state.settings.isFixNavbar
});

const mapDispatchToProps = (dispatch) => ({
    statisticsAction: (e) => dispatch(statisticsAction(e)),
    statisticsCloseAction: (e) => dispatch(statisticsCloseAction(e))
});

export default connect(mapStateToProps, mapDispatchToProps)(Inchargeot);
